import Polygon from '../../images/polygon_icon.png';
import { useTranslation } from 'react-i18next';
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';
import './Pagination.less';

const Pagination = ({
    onClickPageLink = () => {},
    isDisabled = false,
    pageAmount = 10,
    pageIndex = 0,
    maxVisiblePages = 3,
    rangeAroundCurrent = 1, // amount of pages to show on each side of the current page
}) => {
    const { t } = useTranslation();
    const nextPageIndex = pageIndex + 1;
    const prevPageIndex = pageIndex - 1;
    const leftDisabled = prevPageIndex < 0;
    const rightDisabled = nextPageIndex >= pageAmount;
    const allPagesVisible = pageAmount <= maxVisiblePages;

    const renderPages = () => {
        const pages = [];

        if (allPagesVisible) {
            for (let i = 0; i < pageAmount; i++) {
                pages.push(i);
            }
        } else {
            pages.push(0); //First page

            const start = Math.max(1, pageIndex - rangeAroundCurrent);
            const end = Math.min(pageAmount - 2, pageIndex + rangeAroundCurrent);

            if (start > 1) {
                pages.push('start-ellipsis');
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (end < pageAmount - 2) {
                pages.push('end-ellipsis');
            }

            pages.push(pageAmount - 1); //Last page
        }

        return pages;
    };

    return (
        <div className='pagination_wrapper'>
            <div className='pagination' disabled={isDisabled}>
                {pageAmount > 1 && (
                    <div className='pagination_content'>
                        <div className='page_links'>
                            <button
                                className='page_link left'
                                disabled={leftDisabled || isDisabled}
                                title={t('Left')}
                                onPointerUp={(e) => {
                                    callIfPointerSupported(() => {if(!leftDisabled && !isDisabled)onClickPageLink(prevPageIndex)}, e);
                                }}
                                onTouchStart={(e) => {
                                    callIfTouchSupported(() => {if(!leftDisabled && !isDisabled)onClickPageLink(prevPageIndex)});
                                }}
                                onMouseUp={(e) => {
                                    callIfMouseSupported(() => {if(!leftDisabled && !isDisabled)onClickPageLink(prevPageIndex)}, e);
                                }}
                            >
                                <img alt={t('Left')} src={Polygon}/>
                            </button>
                            <div className={allPagesVisible ? 'pages_all_visible' : 'pages'}>
                                {renderPages().map((page, index) => {
                                    if (page === 'start-ellipsis' || page === 'end-ellipsis') {
                                        return (
                                            <span key={page + index} className="ellipsis">
                                                ...
                                            </span>
                                        );
                                    }

                                    const isSelected = page === pageIndex;
                                    const pageNum = page + 1;
                                    return (
                                        <button
                                            key={`page${page}`}
                                            className={isSelected ? 'page_link_selected' : 'page_link'}
                                            disabled={isDisabled}
                                            title={t('Page') + " " + (pageNum)}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                            }}
                                            onPointerUp={(e) => {callIfPointerSupported(() => onClickPageLink(page), e);}}
                                            onTouchStart={(e) => {callIfTouchSupported(() => onClickPageLink(page));}}
                                            onMouseUp={(e) => {callIfMouseSupported(() => onClickPageLink(page), e);}}
                                        >
                                            <label>{pageNum}</label>
                                        </button>
                                    );
                                })}
                            </div>
                            <button
                                className='page_link right'
                                disabled={rightDisabled || isDisabled}
                                title={t('Right')}
                                onPointerUp={(e) => {
                                    callIfPointerSupported(() => {if(!rightDisabled && !isDisabled)onClickPageLink(nextPageIndex)}, e);
                                }}
                                onTouchStart={(e) => {
                                    callIfTouchSupported(() => {if(!rightDisabled && !isDisabled)onClickPageLink(nextPageIndex)});
                                }}
                                onMouseUp={(e) => {
                                    callIfMouseSupported(() => {if(!rightDisabled && !isDisabled)onClickPageLink(nextPageIndex)}, e);
                                }}
                            >
                                <img alt={t('Right')} src={Polygon}/>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Pagination;